import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Theme } from "@mui/material";
import { AlertColor } from "@mui/material/Alert/Alert";
import { Components } from "@mui/material/styles";
import { colors } from "../globalColors";
import { lxColor } from "../useLxColor";

const alertStyleOverrides = (theme: unknown, color: AlertColor) => {
  const colors = lxColor(theme as Theme);
  return {
    backgroundColor: colors[color].background,
    color: colors[color].text,
    "& .MuiAlert-icon": {
      color: colors[color].main,
    },
  };
};

export const components: Components = {
  MuiAlert: {
    styleOverrides: {
      standardSuccess: ({ theme }) => alertStyleOverrides(theme, "success"),
      standardInfo: ({ theme }) => alertStyleOverrides(theme, "info"),
      standardWarning: ({ theme }) => alertStyleOverrides(theme, "warning"),
      standardError: ({ theme }) => alertStyleOverrides(theme, "error"),
      outlinedSuccess: ({ theme }) => alertStyleOverrides(theme, "success"),
      outlinedInfo: ({ theme }) => alertStyleOverrides(theme, "info"),
      outlinedWarning: ({ theme }) => alertStyleOverrides(theme, "warning"),
      outlinedError: ({ theme }) => alertStyleOverrides(theme, "error"),
      root: {
        "& .MuiLink-root": {
          color: "inherit",
          fontWeight: 700,
        },
      },
    },
    defaultProps: {
      iconMapping: {
        success: <CheckCircleOutlineOutlinedIcon />,
        error: <ErrorOutlineRoundedIcon />,
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: colors.grey800, // "#424242",
      },
      root: ({ ownerState }) => ({
        ...((ownerState.color === "primary" ||
          ownerState.color === "secondary") && {
          "& .MuiButton-contained.Mui-disabled": {
            color: "rgba(255,255,255,0.5)",
            backgroundColor: "rgba(255,255,255,0.12)",
          },
        }),
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: "1rem",
        fontWeight: 600,
        letterSpacing: "-0.006em",
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        lxPageTitle: "div",
        lxDialogTitle: "div",
        lxSectionTitle: "div",
        lxWidgetTitle: "div",
        lxCardTitle: "div",
        lxSubtitle1: "div",
        lxSubtitle2: "div",
        lxFieldsetTitle: "div",
        lxBody1: "div",
        lxBody2: "div",
        lxBody3: "div",
        lxCaption: "div",
        lxOverline: "div",
        lxButtonLarge: "div",
        lxButtonMedium: "div",
        lxButtonSmall: "div",
        lxAvatarLetter: "div",
        lxInputLabel: "div",
        lxHelperText: "div",
        lxInputInputText: "div",
        lxTooltip: "div",
      },
    },
  },
};
